import { render, staticRenderFns } from "./ModalProcessoArtefatoGeral.vue?vue&type=template&id=b421ca8c"
import script from "./ModalProcessoArtefatoGeral.vue?vue&type=script&lang=js"
export * from "./ModalProcessoArtefatoGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports